// A session's rare-effort line (api/lib/rareEffort.js): its one best slice
// against your own year on the same machine, such as "Best 2 km this year:
// 7:41.8". Personal stats, so it shows whether badges are on or not.

import React from "react";
import { Sparkles } from "lucide-react";
import { cn } from "../../lib/utils";

/** The line, or nothing when the session has none. */
const RareEffort = ({ effort, className }) =>
  effort?.text ? (
    <span className={cn("flex min-w-0 items-center gap-1 text-xs font-medium text-amber-300", className)}>
      <Sparkles className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span className="truncate">{effort.text}</span>
    </span>
  ) : null;

export default RareEffort;
